/**
 * @desc 获取箱唛文件
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.GetBoxLabelForGjRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/allocationMaster/getBoxLabelForGj`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
